import React, {useEffect, useRef, useState} from "react";
import styled from "styled-components";
/** @type {string} */
import IcOrderList from "../../assets/icons/ic-order-list.svg";
/** @type {string} */
import IcOrderBox from "../../assets/icons/ic-order-box.svg";
import CheckBox from "../common/Checkbox";
/** @type {string} */
import IcFolder from "../../assets/icons/ic-folder.svg";
/** @type {string} */
import IcFile from "../../assets/icons/ico-file.svg";
import Input from "../../components/common/Input";
import {useStore} from "../../app/store";
import TreeView from "../explorer/TreeView";
import {ModalBody} from "./Modal";
import {observer} from "mobx-react";
import {toast} from "react-toastify";
import "../../styles/folder-style.scss"
import {folderFileNameNotAllow, getErrorText} from "../../app/util";


const EditorFolderModal = ({modalMutate, modalDepth}) => {
    const [viewType, setViewType] = useState("gallery");
    const [contextOpen, setContextOpen] = useState(false);
    const [targetX, setTargetX] = useState(0);
    const [targetY, setTargetY] = useState(0);
    const contextRef = useRef(null);
    const [nameChangeInput, setNameChangeInput] = useState("");
    const setNameChangeInputFocus = useRef([]);
    const setNameChangeInputFileFocus = useRef([]);
    const [changeInputIdx, setChangeInputIdx] = useState(null);
    const [changeInputType, setChangeInputType] = useState("");
    const [changeInputVal, setChangeInputVal] = useState('');
    const [focusInput, setFocusInput] = useState('');
    const {folderStore, modalStore, confirmStore} = useStore();
    const specialCharRegex = /[~!@#$%^&*+`={}|\\:;"'<>,.?/]/;
    useEffect(() => {
        const handler = (event) => {
            if (contextRef.current && !contextRef.current.contains(event.target)) {
                setContextOpen(false);
            }
        };
        document.addEventListener("mousedown", handler);
        folderStore.setCurrentFolderInModal(modalDepth, folderStore.editorBoardList.path, folderStore.folders[folderStore.editorBoardList.path])
        folderStore.clearSaveItems();
        return () => {
            document.removeEventListener("mousedown", handler);
            folderStore.clearInModal(modalDepth, folderStore.editorBoardList.path);
            folderStore.clearSaveItems();
        }
    }, []);
    const singleChk = (checked, item) => {
        if (checked) {
            folderStore.pushSaveItems(item);
        } else {
            folderStore.removeSaveItems(item);
        }
    }


    const onContextMenu = (e, itm, index, type) => {
        e.preventDefault();
        setTargetX(e.clientX);
        setTargetY(e.clientY);
        setContextOpen(true);
        if (type === 'folder') {
            setChangeInputType('folder');
        } else if (type === 'file') {
            setChangeInputType('file');
        }
        setChangeInputVal(itm.name);
        setChangeInputIdx(index);
        if (changeInputIdx !== index || type !== changeInputType) {
            setNameChangeInput("");
        }
        folderStore.clearSaveItems();
        folderStore.pushSaveItems(itm);
    }
    const boardManagePopMenu = async (type) => {
        if (type === 'change') {
            setNameChangeInput(changeInputType);
        } else {
            if (folderStore.getSaveItems().length > 0) {
                if (type === 'delete') {
                    await onClickDelete()
                } else if (type === 'copy') {
                    await onClickDuplicate()
                } else if (type === 'move') {
                    await onClickMove()
                }
            } else {
                toast("항목을 체크해주세요");
            }
        }
        setContextOpen(false);
    }
    useEffect(() => {


        if (nameChangeInput === "folder") {
            if (setNameChangeInputFocus.current[changeInputIdx]) {
                setNameChangeInputFocus.current[changeInputIdx].querySelector("#nameChangeInput")?.focus();
            }
        } else if (nameChangeInput === "file") {
            if (setNameChangeInputFileFocus.current[changeInputIdx]) {
                setNameChangeInputFileFocus.current[changeInputIdx].querySelector("#nameChangeInput")?.focus();
            }
        }
    }, [nameChangeInput]);


    useEffect(() => {
        if (focusInput === 'active') {
            modalStore.setIsOpenChangeName(true);
        }
    }, [focusInput]);


    const onClickAddFolder = () => {
        let length = folderStore.getCurrent(folderStore.editorBoardList.path, 0).depth;
        if (length >= 4) {
            toast("신규 폴더를 생성할 수 없습니다.");
        } else {
            folderStore.setAddFolder('ETC', true);
        }
    }
    const onClickDelete = async () => {
        if (folderStore.getSaveItems().length === 0) {
            return toast(`항목을 선택해주세요.`);
        }
        confirmStore.openConfirm({
            confirmText: "확인",
            text: "해당파일을 삭제하시겠습니까?",
            confirmFunc: async () => {
                try {
                    await folderStore.deleteList(folderStore.editorBoardList.path);
                    // folderStore.clearInModal(modalDepth, folderStore.editorBoardList.path);
                    await modalMutate();
                    folderStore.setCurrentAfterActionInModal(folderStore.editorBoardList.path, modalDepth);
                    toast(`삭제 완료되었습니다.`);
                } catch (e) {
                    console.log(`err => ${e.message}`);
                } finally {
                    folderStore.clearSaveItems();
                    confirmStore.clear();
                }
            },
        });


    }

    const onClickDuplicate = async () => {
        if (folderStore.getSaveItems().length === 0) {
            return toast(`항목을 선택해주세요.`);
        }
        try {
            await folderStore.duplicateList(folderStore.editorBoardList.path)
            // folderStore.clearInModal(modalDepth, folderStore.editorBoardList.path);
            await modalMutate();
            folderStore.setCurrentAfterActionInModal(folderStore.editorBoardList.path, modalDepth);
            folderStore.clearSaveItems();
            toast(`복제 되었습니다`);
        } catch (e) {
            console.log(`err => ${e.message}`);
        }
    }

    const onClickMove = () => {
        if (folderStore.getSaveItems().length === 0) {
            toast("항목을 체크해주세요");
        } else {
            modalStore.openModal({
                ...modalStore.MODAL_PAYLOAD.MOVE_ITEM(folderStore.editorBoardList.path),
            }, (async () => {
                await modalMutate();
                folderStore.setCurrentAfterActionInModal(folderStore.editorBoardList.path, modalDepth);
            }));
        }
        setContextOpen(false); // 우클릭 팝업 초기화
    }


    const changeItemNameFunc = async (e, item) => {
        if (e.nativeEvent.isComposing) return;
        if (changeInputVal !== '') {
            if (changeInputVal === item.name) {
                toast('현재와 동일한 이름 입니다.');
                return;
            } else if (folderFileNameNotAllow(changeInputVal)) {
                toast("사용 불가능한 문자가 포함 되어있습니다.");
                return;
            } else {
                try {
                    await folderStore.changeName(folderStore.editorBoardList.path, item, changeInputVal)
                    await modalMutate();
                    folderStore.setCurrentAfterActionInModal(folderStore.editorBoardList.path, 0);
                    folderStore.clearSaveItems();
                    toast(`변경 완료되었습니다.`);
                } catch (e) {
                    if (e.code && e.code === "ALREADY_EXIST_FILE_NAME") {
                        toast(getErrorText(e.code));
                    }
                } finally {
                    setNameChangeInput("");
                }
            }
        } else {
            toast('이름을 입력해주세요.')
        }
        modalStore.setIsOpenChangeName(false);
    }
    const addFolderAction = async (e) => {
        if (e.nativeEvent.isComposing) return;
        try {
            await folderStore.addNewFolderFunc(e.target.value, folderStore.editorBoardList.path, modalDepth);
            await modalMutate();
            folderStore.setCurrentFolderInModal(modalDepth, folderStore.editorBoardList.path, folderStore.getCurrent(folderStore.editorBoardList.path, modalDepth));
            e.target.value = ""; // input 폴더명 비우기
            toast(`신규 폴더가 생성 되었습니다.`);
        } catch (e) {
            console.log(e);
        } finally {
            folderStore.setAddFolder('ETC', false);
        }
    }

    const [overFolderName, setOverFolderName] = useState('');
    const [fullNameLocX, setFullNameLocX] = useState(0);
    const [fullNameLocY, setFullNameLocY] = useState(0);
    const [fullNameMargin, setFullNameMargin] = useState(0);
    return (
        <ModalBody id="FolderEditorModal">
            <EditFolderModalWrap>
                <div className={"list-wrap"}>
                    <div className={"list-folder-wrap"}>
                        <div className={"list-menu-wrap"}>
                            <p className={"name"}>즐겨찾기</p>
                            {
                                folderStore.getBookmarks(folderStore.editorBoardList.path, true).length > 0 ||
                                folderStore.addBookmarkInModal[folderStore.editorBoardList.path] ?
                                    <TreeView
                                        treeType={'Bookmark'}
                                        entryType={folderStore.editorBoardList.path}
                                        mutateFoldersAndBookmarks={modalMutate}
                                        isActionModal={true}
                                        modalDepth={modalDepth}
                                        withIcon={true}
                                        withFiles={true}
                                    ></TreeView>
                                    : <div className={"no-entry-folder"}>
                                        {
                                            {
                                                temp: '즐겨찾는 템플릿이 없습니다.',
                                                clip: '즐겨찾는 클립보드가 없습니다.',
                                                comm: '즐겨찾는 공통보드가 없습니다.'
                                            }[folderStore.editorBoardList.link]
                                        }
                                    </div>
                            }
                        </div>
                        <div className={"list-menu-wrap"}>
                            <p className={"name"}>{folderStore.editorBoardList.name}</p>
                            {
                                folderStore.folders[folderStore.editorBoardList.path].children.length &&
                                folderStore.folders[folderStore.editorBoardList.path].children.length > 0 ?
                                    <TreeView
                                        treeType={'Folder'}
                                        entryType={folderStore.editorBoardList.path}
                                        mutateFoldersAndBookmarks={modalMutate}
                                        isActionModal={true}
                                        modalDepth={modalDepth}
                                        withIcon={true}
                                    ></TreeView>
                                    : <div className={"no-entry-folder"}>
                                        {[folderStore.editorBoardList.name]} 폴더가 존재 하지 않습니다.
                                    </div>
                            }

                        </div>
                    </div>
                    <div className={"list-box-wrap"}>
                        <div className="list-box-header">
                            <div className="action-btn-wrap">
                                <button onClick={onClickAddFolder}>
                                    <span>폴더추가</span>
                                </button>
                                <button onClick={onClickDelete}>
                                    <span>삭제</span>
                                </button>
                                <button onClick={onClickDuplicate}>
                                    <span>복제</span>
                                </button>
                                <button onClick={onClickMove}>
                                    <span>이동</span>
                                </button>
                            </div>
                            <div className="ordering-btn-wrap">
                                <button className={"gallery"} onClick={() => setViewType("gallery")}>
                                    <img src={IcOrderBox} alt="box icon"/>
                                </button>
                                <button className={"list"} onClick={() => setViewType("list")}>
                                    <img src={IcOrderList} alt="list icon"/>
                                </button>
                            </div>
                        </div>
                        {
                            (folderStore.getCurrent(folderStore.editorBoardList.path, 0) && folderStore.getCurrent(folderStore.editorBoardList.path, 0).children.length + folderStore.getCurrent(folderStore.editorBoardList.path, 0).files.length > 0) || folderStore.addFolder.ETC ?
                                <div className={`list-box-container ${viewType}`}>
                                    {
                                        folderStore.getCurrent(folderStore.editorBoardList.path, 0) && folderStore.getCurrent(folderStore.editorBoardList.path, 0).children.map((item, idx) => (
                                            <div className="box-wrap" key={idx}
                                                 onContextMenu={(e) => {
                                                     onContextMenu(e, item, idx, 'folder');
                                                 }}
                                            >
                                                <div className="list-thumbnail-wrap">
                                                    <CheckBox
                                                        className={"checkbox"}
                                                        id={"chk_" + idx}
                                                        onChange={(e) => {
                                                            singleChk(e.target.checked, item);
                                                        }}
                                                        children={""}
                                                        checked={folderStore.checkSaveItems(item)}
                                                    />
                                                    <div className="thumbnail-wrap"
                                                         onDoubleClick={(e) => {
                                                             folderStore.setCurrentFolderInModal(modalDepth, folderStore.editorBoardList.path, item);
                                                         }}
                                                    >
                                                        <img src={IcFolder} alt="folder icon"/>
                                                    </div>
                                                    <div className={"list-name-wrap"}
                                                         ref={(el) => setNameChangeInputFocus.current[idx] = el}>

                                                        <div className="list-name-area">
                                                                <span
                                                                    onMouseEnter={(e) => {
                                                                        setFullNameLocX(e.target.getBoundingClientRect().x);
                                                                        setFullNameLocY(e.target.getBoundingClientRect().y);
                                                                        setFullNameMargin((e.target.offsetWidth - e.target.parentElement.offsetWidth) / 2);
                                                                        if (viewType === "gallery") {
                                                                            if (e.currentTarget.offsetWidth > 154) {
                                                                                setOverFolderName(item.name);
                                                                            }
                                                                        } else if (viewType === "list") {
                                                                            if (e.currentTarget.offsetWidth > 444) {
                                                                                setOverFolderName(item.name);
                                                                            }
                                                                        }
                                                                    }}
                                                                    onMouseLeave={() => {
                                                                        setOverFolderName("");
                                                                        setFullNameLocX(0);
                                                                        setFullNameLocY(0);
                                                                        setFullNameMargin(0);
                                                                    }}
                                                                >{item.name}</span>
                                                        </div>
                                                        {
                                                            changeInputIdx === idx &&
                                                            nameChangeInput === "folder" &&
                                                            <Input
                                                                inputType={"text"}
                                                                id={"nameChangeInput"}
                                                                className={`input-name ${focusInput}`}
                                                                placeholder={"이름을 입력해주세요."}
                                                                onChange={(e) => {
                                                                    setChangeInputVal(e.target.value);
                                                                }}
                                                                onBlur={async (e) => {
                                                                    await changeItemNameFunc(e, item);
                                                                    setFocusInput("");
                                                                }}
                                                                onKeyDown={async (e) => {
                                                                    if (e.key === "Enter") {
                                                                        await changeItemNameFunc(e, item);
                                                                    } else if (e.key === "Escape") {
                                                                        setNameChangeInput("");
                                                                    }
                                                                    setFocusInput("");
                                                                }}
                                                                onFocus={() => {
                                                                    setFocusInput('active');
                                                                }}
                                                                value={changeInputVal}
                                                            />
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    }
                                    {
                                        folderStore.getCurrent(folderStore.editorBoardList.path, 0) && folderStore.getCurrent(folderStore.editorBoardList.path, 0).files.map((item, idx) => (
                                            <div className="box-wrap" key={idx}
                                                 onContextMenu={(e) => {
                                                     onContextMenu(e, item, idx, 'file');
                                                 }}
                                            >
                                                <div className="list-thumbnail-wrap">
                                                    <CheckBox
                                                        className={"checkbox"}
                                                        id={"chk_" + ((folderStore.getCurrent(folderStore.editorBoardList.path, 0) && folderStore.getCurrent(folderStore.editorBoardList.path, 0).children ? folderStore.getCurrent(folderStore.editorBoardList.path, 0).children : []).length + idx)}
                                                        onChange={(e) => {
                                                            singleChk(e.target.checked, item)
                                                        }}
                                                        children={""}
                                                        checked={folderStore.checkSaveItems(item)}
                                                    />
                                                    <div className="thumbnail-wrap">
                                                        <img src={IcFile} alt="folder icon"/>
                                                    </div>
                                                    <div className={"list-name-wrap"}
                                                         ref={(el) => setNameChangeInputFileFocus.current[idx] = el}>
                                                        <div className="list-name-area">
                                                                <span
                                                                    onMouseEnter={(e) => {
                                                                        setFullNameLocX(e.target.getBoundingClientRect().x)
                                                                        setFullNameLocY(e.target.getBoundingClientRect().y)
                                                                        setFullNameMargin((e.target.offsetWidth - e.target.parentElement.offsetWidth) / 2);

                                                                        // setFullNameMargin
                                                                        if (viewType === "gallery") {
                                                                            if (e.currentTarget.offsetWidth > 154) {
                                                                                setOverFolderName(item.name);
                                                                            }
                                                                        } else if (viewType === "list") {
                                                                            if (e.currentTarget.offsetWidth > 444) {
                                                                                setOverFolderName(item.name);
                                                                            }
                                                                        }
                                                                    }}
                                                                    onMouseLeave={() => {
                                                                        setOverFolderName("");
                                                                        setFullNameLocX(0);
                                                                        setFullNameLocY(0);
                                                                        setFullNameMargin(0);
                                                                    }}
                                                                >{item.name}</span>
                                                        </div>
                                                        {
                                                            // changeInputFileIdx === idx &&
                                                            // nameChangeInputFile &&
                                                            changeInputIdx === idx &&
                                                            nameChangeInput === "file" &&
                                                            <Input
                                                                inputType={"text"}
                                                                id={"`nameChangeInput`"}
                                                                className={`input-name ${focusInput}`}
                                                                placeholder={"이름을 입력해주세요."}
                                                                autoFocus={true}
                                                                onChange={(e) => {
                                                                    setChangeInputVal(e.target.value)
                                                                }}


                                                                onBlur={async (e) => {
                                                                    await changeItemNameFunc(e, item);
                                                                    setFocusInput("");
                                                                }}
                                                                onKeyDown={async (e) => {
                                                                    if (e.key === "Enter") {
                                                                        await changeItemNameFunc(e, item);
                                                                    } else if (e.key === "Escape") {
                                                                        setNameChangeInput("");
                                                                    }
                                                                    setFocusInput("");
                                                                }}
                                                                onFocus={() => {
                                                                    setFocusInput('active');
                                                                }}
                                                                value={changeInputVal}
                                                            />
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    }
                                    {
                                        folderStore.addFolder.ETC &&
                                        <div className="box-wrap"
                                             key={folderStore.getCurrent(folderStore.editorBoardList.path, 0) && folderStore.getCurrent(folderStore.editorBoardList.path, 0).children.length + folderStore.getCurrent(folderStore.editorBoardList.path, 0).files.length + 1}>
                                            <div className="list-thumbnail-wrap">
                                                <CheckBox
                                                    className={"checkbox"}
                                                />
                                                <div className="thumbnail-wrap">
                                                    <img src={IcFolder} alt="folder icon"/>
                                                </div>
                                                <div className={"new-folder-add-wrap"}>
                                                    <Input
                                                        inputType={"text"}
                                                        id={"newAddFolder"}
                                                        placeholder={"새 폴더"}
                                                        autoFocus={true}
                                                        autocomplete={'off'}
                                                        onBlur={async (e) => {
                                                            if (e.target.value.trim() === "") {
                                                                return folderStore.setAddFolder('ETC', false);
                                                            }
                                                            // if (e.stopPropagation) return e.stopPropagation();
                                                            await addFolderAction(e);
                                                        }}
                                                        onKeyDown={async (ev) => {
                                                            // eslint-disable-next-line default-case
                                                            switch (ev.key) {
                                                                case 'Escape':
                                                                    folderStore.setAddFolder('ETC', false); // 인풋 닫기
                                                                    break;
                                                                case 'Enter':
                                                                    await addFolderAction(ev);
                                                                    break;
                                                                default:
                                                                    //console.log('default')
                                                                    break;
                                                            }
                                                        }}

                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                                : <div className={"no-folder"}>데이터가 존재 하지 않습니다.</div>
                        }
                    </div>
                </div>
            </EditFolderModalWrap>
            {
                contextOpen &&
                <ContextMenu ref={contextRef} top={targetY} left={targetX}>
                    <div className={"list"} onClick={async () => await boardManagePopMenu("delete")}>삭제</div>
                    <div className={"list"} onClick={async () => await boardManagePopMenu("copy")}>복제</div>
                    <div className={"list"} onClick={async () => await boardManagePopMenu("move")}>이동</div>
                    <div className={"list"} onClick={async () => await boardManagePopMenu("change")}>이름바꾸기</div>
                </ContextMenu>
            }

            {
                overFolderName !== '' &&
                <div
                    className={`name_hover`}
                    style={{
                        top: `${fullNameLocY + 20}px`,
                        left: `${fullNameLocX}px`,
                        marginLeft: `-${fullNameMargin}px`
                    }}
                >
                    <span>{overFolderName}</span>
                </div>
            }
        </ModalBody>
    );
};

const Modal = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9999;


    .editor-folder-move {
        top: 0;
        left: 0;
        transform: translate(0, 0);
        width: 100%;
        height: 100%;

        > div {
            display: flex;
            width: 440px;
            max-height: 630px;
        }

        .modal-container {
            width: 100%;
        }
    }

    &.folder-move-open {
        .modal-container-table {
            z-index: 99;
        }

        .editor-folder-move {
            z-index: 101;
        }
    }
`;

const EditFolderModalWrap = styled.div`
    width: 100%;
    height: 100%;

    h1 {
        color: #FFF;
        font-size: 16px;
        font-weight: 700;
        line-height: 24px;
        letter-spacing: -0.16px;
    }

    .list-wrap {
        display: flex;
        height: 100%;
        position: relative;
        background: #fff;
        overflow: hidden;

        .no-folder {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 12px;
        }

        .list-folder-wrap {
            width: 260px;
            background-color: #FAFAFA;
            border-right: 1px solid #EEE;
            height: 100%;

            .list-menu-wrap {
                padding-bottom: 16px;

                &:first-child {
                    max-height: 126px;
                    overflow: hidden;
                    overflow-y: scroll;
                }

                .name {
                    color: #3B3B3B;
                    font-size: 13px;
                    font-weight: 500;
                    line-height: 18px;
                    letter-spacing: -0.13px;
                    padding: 20px 16px 0px;

                }

                + .list-menu-wrap {
                    border-top: 1px solid #EEE;
                    max-height: calc(100% - 126px);
                    overflow: hidden;
                    overflow-y: scroll;
                }

                .no-entry-folder {
                    text-align: center;
                    padding: 16px 0;
                    color: #B0B0B0;
                    font-size: 12px;
                    font-weight: 400;
                    letter-spacing: -0.12px;
                }
            }
        }
    }

    div.list-box-wrap {

        height: 100%;
        position: relative;
        overflow: hidden;
        overflow-y: scroll;
        width: calc(100% - 260px);

        div.list-box-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: sticky;
            top: 0;
            left: 0;
            background: #fff;
            z-index: 101;
            padding: 32px 32px 16px;
        }

        div.action-btn-wrap {
            display: flex;
            align-items: center;
            gap: 10px;

            span {
                color: #c8c8c8;
                font-size: 12px;
                font-style: normal;
                font-weight: 400;
                line-height: 16px;
                letter-spacing: -0.12px;

                &.active {
                    color: #262626;
                }
            }
        }

        div.ordering-btn-wrap {
            display: flex;
            gap: 4px;
            align-items: center;

            button {
                width: 24px;
                height: 24px;
                text-align: right;

                img {
                    display: inline-block;
                }
            }
        }
    }

    .content-header {
        position: relative;
        padding: 12px 24px;
        background-color: #262626;

        svg {
            position: absolute;
            top: 12px;
            right: 24px;
            cursor: pointer;
        }
    }

    .list-box-container {
        font-size: 12px;
        padding: 0 32px 32px;


        .list-thumbnail-wrap {
            position: relative;

            .new-folder-add-wrap {
                width: 100%;
            }
        }

        .list-name-wrap {
            width: 100%;
            position: relative;

            .input-name {
                width: 100%;
                position: absolute;
                top: 0;
                left: 0;
                z-index: 1;

                &.active {
                    box-shadow: 0px 0px 8px 0px rgba(222, 149, 97, 0.20);
                }

                input {
                    border-radius: 2px;
                    border: 1px solid #DE9561;

                    outline: none;
                }
            }
        }

        .list-name-area {
            width: 100%;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            cursor: default;
            position: relative;

            > span {
                font-size: 12px;
                font-style: normal;
                font-weight: 400;
                line-height: 16px;
                letter-spacing: -0.12px;
                color: #262626;
                padding: 0 2px;
            }
        }

        &.gallery .box-wrap {
            width: calc(33.33% - 12px);
            margin-right: 18px;
            margin-bottom: 24px;
            display: inline-block;

            &:nth-of-type(3n) {
                margin-right: 0;
            }

            .list-thumbnail-wrap {
                .new-folder-add-wrap {
                    margin-top: 4px;
                }

                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;

                & .checkbox {
                    position: absolute;
                    top: 10px;
                    left: 10px;
                    z-index: 10;
                }

                & .thumbnail-wrap {
                    width: 100%;
                    height: 128px;
                    border: 1px solid #eee;
                    position: relative;

                    img {
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                    }
                }

                & .restDate {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, 0);
                    text-align: center;
                    color: #FF0000;
                    font-size: 12px;
                }
            }

            .list-name-area {
                margin-top: 4px;
                padding: 8px 0;
                text-align: center;
                line-height: 1;
            }

            .input-name {
                top: 4px;
            }
        }

        // 리스트

        &.list .box-wrap {
            width: 100%;
            padding: 6px 16px 6px 12px;
            height: 44px;
            border-top: 1px solid #ccc;

            .list-thumbnail-wrap {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: flex-start;
                height: 100%;

                .thumbnail-wrap {
                    width: 18px;
                    margin: 0 10px;
                    flex-shrink: 0;
                }

                .list-name-wrap {
                    min-width: 0;
                    height: 100%;
                    display: flex;
                    align-items: center;
                }

                .list-name-area {
                    order: 1;
                }

                .input-name {
                    top: 50%;
                    height: 100%;
                    transform: translateY(-50%);

                    .input-wrapper {
                        height: 100%;

                        input {
                            height: 100%;
                        }
                    }
                }

                .restDate {
                    order: 2;
                    margin-left: auto;
                }

            }
        }

        &.list .box-wrap:last-child {
            border-bottom: 1px solid #ccc;
        }
    }
`;


const ModalContainer = styled.article`

    height: 720px;
    width: 840px;
    margin: 0 auto;
    //overflow: hidden;
    border-radius: 10px;
    max-height: 90vh;
    position: relative;
    z-index: 105;
`;

const Dimmer = styled.div`
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 20px;
    background-color: rgba(0, 0, 0, 0.4);
    display: flex;
    justify-content: center;
    align-items: center;
`;

const TableDisplay = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 100;


`;
const ContextMenu = styled.div`
    position: fixed;
    top: ${(props) => props.top + "px"};
    left: ${(props) => props.left + "px"};
    border-radius: 4px;
    z-index: 999999;
    overflow: hidden;
    width: 104px;

    & .list {
        font-weight: 400;
        padding: 3px 12px;
        color: #fff;
        font-size: 12px;
        cursor: pointer;
        background-color: #262626;
        line-height: 1;

        &:hover {
            background-color: #313131;
        }
    }

    & .list:first-child {
        padding: 7px 12px 3px;
    }

    & .list:last-child {
        padding: 3px 12px 7px;
    }
`;

export default observer(EditorFolderModal);
